import { render, staticRenderFns } from "./Empty4.vue?vue&type=template&id=431cd84e&scoped=true"
import script from "./Empty4.vue?vue&type=script&lang=js"
export * from "./Empty4.vue?vue&type=script&lang=js"
import style0 from "./Empty4.vue?vue&type=style&index=0&id=431cd84e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431cd84e",
  null
  
)

export default component.exports